/**
 * Step by step sidebar UI component
 * @param  data 
 * @returns 
 * data : Array
 * relatedLinks : array
 * relatedlink.url : string
 * relatedlink.text : rawHtml string
 * 
 */ 

import React, { useState } from "react";
import _ from "lodash"
import {Link} from "gatsby"

function removeSlashes(URL){
    return URL.replace(/\//g,'');
}

function StepbySteps(props) {
    const [isActive, setActive] = useState("false");
    const handleAllToggle = () => {
        setActive(!isActive);
    };
    if(!_.isNil(props.data)){

        let steps = [];    

        //console.log(props.stepperInfo.stepperName);
        let stepTitle   = props.stepperInfo.stepperName;
        let stepLink    = props.stepperInfo.stepperUri;
        let i = 0;

        props.data.forEach(StepByStep => {
            i++;
            let activeLinks = '';
            const stepLinks = [];
        
            let currentStepPosts = StepByStep.posts.nodes;
            for(const StepByStepPosts in currentStepPosts) {
                //if(currentStepPosts[StepByStepPosts].uri.includes(props.currentURL)) {
                //    activeLinks = 'step--active step--current-active'
                //}
                if(removeSlashes(currentStepPosts[StepByStepPosts].uri) === removeSlashes(props.currentURL)){
                    activeLinks = 'step--active step--current-active'
                }
            stepLinks.push(
                    <li>
                        <a href={currentStepPosts[StepByStepPosts].uri}>{currentStepPosts[StepByStepPosts].title}</a>
                    </li>
                )
            }
        
            steps.push(
                <li className={activeLinks + ' steps-list_step'}>
                    <h4>
                        <span className="aria-hide">{i}</span>
                        <span className="steps-list_name">{StepByStep.name}</span>
                    </h4>
                    {!_.isEmpty(activeLinks) &&         
                        <div class={isActive ? "steps-list__excerpt " : "steps-list__excerpt"}>
                            {StepByStep.stepByStepDescription} 
                            <ul class="steps-list_nextlinks">
                                {stepLinks}
                            </ul>
                        </div>
                    }
                    
                    {_.isEmpty(activeLinks) && 
                        <div class={isActive ? "steps-list__excerpt hidden" : "steps-list__excerpt"}>
                            {StepByStep.stepByStepDescription} 
                            <ul class="steps-list_nextlinks">
                                {stepLinks}
                            </ul>
                        </div>
                    }
                </li>
            )
        })

        if(!_.isEmpty(stepTitle)){
            return (
                <div className="step-list">
                    <div className="step-list--partof">
                        <h4>Part of: <a href={'/'+stepLink}>{stepTitle}</a></h4>
                        <div className="steps-list_toggle--all text-right">
                            <button className="inline-link" onClick={handleAllToggle}>Show all</button>
                        </div>
                    </div>
                    <ol className="steps-list mtop-20 mbottom-20">
                        {steps}
                    </ol>
                </div>
            )
        } else {
            return null
        }
 
    } else {
        return null
    }
}
export default StepbySteps